namespace GeniuzPOS.PosShift {
    export enum VatRefundAmtFg {
        Fix = 0,
        Percent = 1
    }
    Serenity.Decorators.registerEnumType(VatRefundAmtFg, 'GeniuzPOS.PosShift.VatRefundAmtFg');
}
